<form nz-form style="padding-top:12px;padding-right:12px" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
      <div nz-col nzSm="24" nzMd="24"> 
          <nz-form-item>
            <nz-form-label nzSpan="24" nzRequired>Dạng tật</nz-form-label>
            <asc-autocomplete [ascModel]="TypeDisabilityControl" (ascModelChange)="changeTypeDisability($event)"
              [placeholder]="'Chọn dạng...'" [getListAC]="getTypeDisabilityACFn"></asc-autocomplete>
          </nz-form-item> 
      </div>
      <div nz-col nzSm="24" nzMd="24"> 
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Giáo viên phụ trách</nz-form-label>
          <asc-autocomplete [ascModel]="StaffControl" (ascModelChange)="changeStaff($event)"
            [placeholder]="'Chọn giáo viên...'" [getListAC]="getStaffACFn"></asc-autocomplete>
        </nz-form-item> 
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24">Ghi chú</nz-form-label> 
            <input nz-input [(ngModel)]="itemGVPT.note"
            [ngModelOptions]="{standalone: true}"   type="text" placeholder="Nhập ghi chú...">
        </nz-form-item >
      </div>
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu & Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
        <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>